<template>
  <div class="scores-container">
    <!-- Total Liabilities Card -->
    <div class="risk-score-card">
      <i class="fas fa-building"> Stock Screener</i>
     
        <br><br></div>
  
          <div>
        
            <select v-model="selectedMarket" @change="loadTradingViewWidget">
              <option value="canada">Canada</option>
              <option value="america">United States</option>
            </select>
          </div>
          <div ref="widgetContainer" class="tradingview-widget-container__widget"></div>
       
        </div>

    <br><br><br><br><br>
  </template>
  
  <script>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  
  export default {
    setup() {
      const widgetContainer = ref(null);
      const selectedLocale = ref('en');
      const selectedMarket = ref('canada');
      const showModal = ref(false);
  
      const loadTradingViewWidget = () => {
        widgetContainer.value.innerHTML = ''; // Clear previous widget
  
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-screener.js';
        script.async = true;
        script.innerHTML = JSON.stringify({
          "width": 320,
          "height": 523,
          "defaultColumn": "overview",
          "defaultScreen": "most_capitalized",
          "market": selectedMarket.value, // Set market dynamically
          "showToolbar": true,
          "colorTheme": "light",
          "locale": selectedLocale.value,
          "largeChartUrl": "https://www.riskypaws.com"
        });
  
        widgetContainer.value.appendChild(script);
      };
  
      const checkScreenSize = () => {
        showModal.value = window.innerWidth < 1024; // Adjust breakpoint as needed
      };
  
      onMounted(() => {
        loadTradingViewWidget(); // Load widget with initial settings
        checkScreenSize(); // Check screen size on mount
      });
  
      onBeforeUnmount(() => {
        window.removeEventListener('resize', checkScreenSize);
      });
  
      window.addEventListener('resize', checkScreenSize);
  
      return { widgetContainer, selectedLocale, selectedMarket, loadTradingViewWidget, showModal, checkScreenSize };
    },
  };
  </script>
  
  
  
  <style scoped>
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .content-container {
    background-color: #4A148C; /* Light orange color */
    color: black;
    padding: 20px;
    border-radius: 20px; /* Adjust this value to your preference */
    overflow: hidden; 
  }
  
  .stingy-card {
    flex: 1; /* Take up equal width as the iframe */
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: white;
  }
  
  /* Styling for the dropdown menus */
  .dropdown-container {
    margin: 10px 0;
    display: flex;
    justify-content: center;
  }
  
  select {
    padding: 8px 16px;
    margin: 0 5px;
    border-radius: 5px;
    border: 1px solid #A596F3; /* Purple border */
    background-color: white;
    color: #333;
    font-size: 16px;
    cursor: pointer;
    outline: none;
  }
  
  select:hover {
    background-color: #EEE; /* Light hover effect */
  }
  
  .scores-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  border: 2px solid #4A148C;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  background-color: white; 
  flex-direction: row;
  flex-wrap: wrap;  /* Allows items to move to the next row on smaller screens */
  justify-content: space-around;
  }

  .risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .risk-icon {
  margin-right: 10px;
  font-size: 30px;
  }
</style>